module.exports = __webpack_public_path__ + "static/img/brand-bg@m.1c23841.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/d-steady/brand-bg@m.png
// module id = UowZ
// module chunks = 0